/* eslint-disable react/no-unescaped-entities */
import React, {useState} from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { alpha, useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { Grid } from '@mui/material';
import { Typography } from '@mui/material';
import { TextField } from '@mui/material';
import { Button } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import ReCAPTCHA from 'react-google-recaptcha';


// var instance = new Razorpay ({ key_id: 'rzp_test_AqnJr5FXWNsWOh', key_secret: 'NvCxK4sJ0QQoxra1rZLWuPS0' })

const validationSchema = yup.object({
  otp: yup.number().required('Please enter OTP'),
});

const axios = require('axios').default;
// const Razorpay = require('razorpay');

let isDisabled = true;


const Form = ({ handleCurrentStep, secondState, firstState }) => {

  const [captchaCode, setCaptchaCode] = useState('');

  const onSubmit = () => {
    const data = { ...formik.values, ...firstState };
    axios
      .post('http://204.236.192.144:49159/api/account/login', data)
      .then((response) => {
        if (response.data != null) {
          console.log('aaaaaa', formik.values);

         

          // document.cookie = `tokenData=${JSON.stringify(response.data)}`;

          window.localStorage.setItem(
            'tokenData',
            JSON.stringify(response.data),
          );
          handleCurrentStep(3, formik.values);
          window.location.pathname = '/about';
        }
      })
      .catch(()=> { alert('Please enter the Correct OTP.'); formik.values.otp = ''; } );
    return formik.values;
  };

  const formik = useFormik({
    initialValues: secondState,
    validationSchema: validationSchema,
    onSubmit,
  });

  const onChange = (valueCaptcha) => {
    setCaptchaCode(valueCaptcha.length);
  };

  if (
    formik &&
    formik.values &&
    formik.values.otp &&
    Object.keys(formik.errors).length === 0 &&
    captchaCode
  ) {
    isDisabled = false;
  }

  // const onSubmit = () => {

  //   axios.post("http://204.236.192.144:49159/api/account/login", formik.values)
  //   .then(response => {
  //       if(response.data != null){
  //          console.log('aaaaaa', formik.values);
  //       }
  //     })

  //     handleCurrentStep(3, formik.values);
  //       return formik.values;
  // };

  // axios.post("/create/orderId", values)
  // .then(response => {
  //   instance.orders.create({
  //     amount: 50000,
  //     currency: "INR",
  //     receipt: "rec1",
  //     notes: {
  //       key1: "value3",
  //       key2: "value2"
  //     }
  //   })
  //   console.log(order);
  // })

  return (
    <Box maxWidth={600} margin={'0 auto'}>
      <Box marginBottom={4}>
        <Typography
          variant={'h4'}
          sx={{ fontWeight: 700 }}
          align={'center'}
          gutterBottom
        >
          OTP - Login
        </Typography>
      </Box>
      <Box>
        <div>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <TextField
                sx={{ height: 54 }}
                label="Enter the recieved OTP"
                type="otp"
                variant="outlined"
                color="primary"
                size="medium"
                name={'otp'}
                fullWidth
                defaultValue={formik.values && formik.values.otp}
                onChange={formik.handleChange('otp')}
                error={
                  (formik.touched && formik.touched.otp) ||
                  Boolean(formik.errors && formik.errors.otp)
                }
                helperText={
                  (formik.touched && formik.touched.otp) ||
                  (formik.errors && formik.errors.otp)
                }
              />
            </Grid>
            <br />
            <Grid item container justifyContent={'center'} xs={12}>
              <Box alignContent={'center'}>
                <ReCAPTCHA
                  sitekey="6LdnjA8iAAAAAL0iFw5FQzAk1rnONk2acKVt19a-"
                  onChange={onChange}
                />
              </Box>
            </Grid>
            <br />

            <Box
              component={Button}
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              height={54}
              marginTop={{ xs: 4, sm: 4 }}
              marginLeft={{ xs: 15, sm: 38 }}
              disabled={isDisabled}
              readOnly={isDisabled}
              onClick={onSubmit}
              // href="/about"
            >
              Verify
            </Box>
          </Grid>
        </div>
      </Box>
    </Box>
  );
};
export default Form;
